import { useEffect, useState } from "react";
import { fetchOrganizations } from "../../api/application/organization";
import type { PaginationOptions } from "../../api/domain/pagination";
import type { Organization } from "../../api/infrastructure/organization.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";

export default function useGetOrganizations({
  preloadData = true,
}: { preloadData?: boolean } = {}) {
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [loading, setLoading] = useState(false);

  const fetch = async (options: PaginationOptions) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      const result = await fetchOrganizations(options);
      setOrganizations(result);
    });
    setLoading(false);
  };

  const search = (query: string): Organization[] => {
    const result = organizations.filter(
      (org) =>
        org.name?.toLowerCase().includes(query.toLowerCase()) ||
        org.acronym?.toLowerCase().includes(query.toLowerCase()),
    );
    setOrganizations(result);
    return result;
  };

  useEffect(() => {
    if (!preloadData) return;
    fetch({ limit: 10, page: 1 });
  }, []);

  return {
    organizations,
    refreshOrganizations: fetch,
    searchOrganizations: search,
    loadingOrganizations: loading,
  };
}
